export default function PhotoSlot({ label = "Photo coming soon", ratio = "aspect-[4/3]", dark = false }) {
  return (
    <div
      className={`flex ${ratio} items-center justify-center rounded-2xl border-2 border-dashed ${
        dark ? "border-white/25 bg-white/5 text-white/50" : "border-navy/20 bg-navy/[0.03] text-navy/40"
      }`}
      data-testid="photo-placeholder"
      role="img"
      aria-label={label}
    >
      <div className="px-6 text-center">
        <p className="font-display text-sm font-700 uppercase tracking-[0.2em]">{label}</p>
        <p className="mt-1 text-xs opacity-70">Real Victory Chapel photography will live here</p>
      </div>
    </div>
  );
}
